export const SET_HEADER = 'SET_HEADER';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_SOFTPHONE = 'SET_SOFTPHONE';